<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Unidade Parceira</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('unidadeparceira.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('unidadeparceira.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('unidadeparceira.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'unidade_parceira'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/unidadeparceira"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="pespar_id"
                    detail-row-component="unidade-parceira-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="unidade_geral" slot-scope="props">
                      <span v-if="props.rowData.unidade_geral != null"
                        >{{ props.rowData.unidade_geral.cd }} -
                        {{ props.rowData.unidade_geral.descr }}</span
                      >
                    </template>
                    <template slot="parceira" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.pessoa != null &&
                          props.rowData.pessoa.pessoa_juridica != null
                        "
                        >{{
                          props.rowData.pessoa.pessoa_juridica.razao_social
                        }}
                        -
                        {{
                          onFormataCnpj(
                            props.rowData.pessoa.pessoa_juridica.cnpj
                          )
                        }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          v-if="getPermissionFw('unidadeparceira.update')"
                          ><i class="fa fa-edit"></i
                        ></a>
                        <span v-if="getPermissionFw('unidadeparceira.status')">
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                        </span>
                        <a
                          @click="onCreateRegiao(props.rowData)"
                          v-if="getPermissionFw('unidadeparceira.regiao.store')"
                          v-b-tooltip
                          title="Vincular Região"
                          ><i class="fa fa-home"></i
                        ></a>
                        <a
                          @click="onCreateMunicipio(props.rowData)"
                          v-if="
                            getPermissionFw('unidadeparceira.municipio.store')
                          "
                          v-b-tooltip
                          title="Vincular Municipio"
                          ><i class="fa fa-user"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UnidadeParceiraForm
        ref="UnidadeParceiraForm"
        :metodo="onFilterReset"
        :tabela="'unidade_parceira'"
        :rota="'unidadeparceira'"
      >
      </UnidadeParceiraForm>
      <UnidadeParceiraRegiaoForm
        ref="unidadeparceiraregiaoform"
        :metodo="onFilterReset"
        :tabela="'unidade_parceira_regiao'"
        :rota="'unidadeparceira/regiao'"
      >
      </UnidadeParceiraRegiaoForm>
      <UnidadeParceiraMunicipioForm
        ref="unidadeparceiramunicipioform"
        :metodo="onFilterReset"
        :tabela="'unidade_parceira_municipio'"
        :rota="'unidadeparceira/municipio'"
      >
      </UnidadeParceiraMunicipioForm>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import UnidadeParceiraFilterBar from "./UnidadeParceiraFilterBar";
import UnidadeParceiraForm from "./UnidadeParceiraForm";
import UnidadeParceiraRegiaoForm from "./UnidadeParceiraRegiaoForm";
import UnidadeParceiraMunicipioForm from "./UnidadeParceiraMunicipioForm";
import UnidadeParceiraDetalhes from "./UnidadeParceiraDetalhes";

Vue.component("unidade-parceira-detalhes", UnidadeParceiraDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    UnidadeParceiraForm,
    UnidadeParceiraRegiaoForm,
    UnidadeParceiraMunicipioForm,
    "vuetable-filterbar": UnidadeParceiraFilterBar,
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: "", descr: "", pespar_id: "", status: [] }),
      helpForm: new Form({ statusRecord: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd",
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr",
        },
        {
          name: "__slot:parceira",
          title: "Pessoa",
        },
        {
          name: "__slot:unidade_geral",
          title: "Unidade",
          sortField: "unidade_id",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },

        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
  },
  methods: {
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.pespar_id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        cd: data_filter.cd,
        descr: data_filter.descr,
        status: data_filter.status.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.reload();
      });
    },

    onFormataCnpj(data) {
      return data.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.UnidadeParceiraForm.onCreate();
    },
    onCreateRegiao(data) {
      this.$refs.unidadeparceiraregiaoform.onCreate(data);
    },
    onCreateMunicipio(data) {
      this.$refs.unidadeparceiramunicipioform.onCreate(data);
    },
    onEdit(data) {
      this.id = data.pespar_id;
      this.$refs.UnidadeParceiraForm.onEdit(data, null, this.id);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({ id: data.pespar_id, status: action });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.UnidadeParceiraForm.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
